
export interface ChatSettings {
  autoScroll: boolean;
  showTimestamps: boolean;
  compactMode: boolean;
  soundEnabled: boolean;
}

export interface UISettings {
  showVehicleInput: boolean;
  zenMode: boolean;
}

export interface AppSettings {
  chat: ChatSettings;
  ui: UISettings;
  theme: {
    mode: 'light' | 'dark' | 'system';
    preset: string;
  };
}

class SettingsService {
  private storageKey = 'chat-app-settings';
  
  private defaultSettings: AppSettings = {
    chat: {
      autoScroll: true,
      showTimestamps: false,
      compactMode: false,
      soundEnabled: false
    },
    ui: {
      showVehicleInput: false,
      zenMode: false
    },
    theme: {
      mode: 'system',
      preset: 'default'
    }
  };

  getSettings(): AppSettings {
    try {
      const stored = sessionStorage.getItem(this.storageKey);
      if (stored) {
        return { ...this.defaultSettings, ...JSON.parse(stored) };
      }
    } catch (error) {
      console.warn('Failed to load settings:', error);
    }
    return this.defaultSettings;
  }

  saveSettings(settings: Partial<AppSettings>): void {
    try {
      const current = this.getSettings();
      const updated = { ...current, ...settings };
      sessionStorage.setItem(this.storageKey, JSON.stringify(updated));
    } catch (error) {
      console.error('Failed to save settings:', error);
    }
  }

  resetSettings(): void {
    try {
      sessionStorage.removeItem(this.storageKey);
    } catch (error) {
      console.error('Failed to reset settings:', error);
    }
  }
}

export const settingsService = new SettingsService();
